import { render } from "./ValidateInput2.vue?vue&type=template&id=21650046&scoped=true"
import script from "./ValidateInput2.vue?vue&type=script&lang=js"
export * from "./ValidateInput2.vue?vue&type=script&lang=js"

import "./ValidateInput2.vue?vue&type=style&index=0&id=21650046&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21650046"]])

export default __exports__